import type { SVGProps } from 'react'

export default function SelectedDot(props: SVGProps<SVGSVGElement>) {
	return (
		<svg width="8" height="15" viewBox="0 0 8 15" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<circle cx="2.5" cy="7.5" r="2.5" fill="currentColor" />
		</svg>
	)
}
